import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';

export async function editReturnBookingModal(onConfirm: (res: boolean) => void | Promise<void>) {
	return newConfirmModal(
		'Edit booking',
		<div>
			<h5>
				<FormattedMessage
					id="cart__edit-return-modal__body"
					defaultMessage="Would you like to edit the one-way trip only, or both trips?"
				/>
			</h5>
		</div>,
		{
			cancelText: 'One way',
			confirmText: 'Both trips',
			resolveOnCancel: true,
			resolveOnClose: true,
			shouldCloseOnEsc: false,
			shouldCloseOnOverlayClick: false,
			showCloseButton: true,
		},
	)
		// The user closed or dismissed this modal — newConfirmModal rejects with no value. Caught
		// here, and only here, so it doesn't mask a failure from onConfirm below.
		.catch(() => undefined)
		.then(result => {
			if (typeof result !== 'boolean') {
				return undefined;
			}
			// Returned, not fired and forgotten — see the same note in RemoveReturnBookingModal.
			return onConfirm(result);
		});
}
